import {Transit} from '@/api/OrderRun';
import {SearchCar, SearchDriver} from "@/api/common";
import store from '@/store/index';
import {asyncAjax} from '@/utils'

function _findItem(arr, key) {
    const _index = arr.findIndex(item => item.key === key)
    return arr[_index]
}


const listConfig = [
    {title: '运单号', key: 'planOrder'},
    {title: '路线名称', key: 'roadName', width: 200},
    {
        title: '客户时效', key: 'clientTime',
        showData({clientTime}) {
            const m = ~~clientTime % 60;
            const s = (~~clientTime - m) / 60;
            let _mstr = `${m}分`
            if (s > 0) _mstr = `${s}时` + _mstr
            return _mstr
        }
    },
    {title: '发车时间', key: 'hairCarTime', color: '#163C78', width: 180},
    {
        title: '到达状态', key: 'statusOver',
        color(data) {
            const _m = ~~data.clientTime - (new Date() - new Date(data.hairCarTime)) / 60000;
            if (_m > 0) {
                return '#163C78'
            } else {
                return '#FF5B45'
            }
        },
        showData(data) {
            const _m = ~~data.clientTime - (new Date() - new Date(data.hairCarTime)) / 60000;
            if (_m > 0) {
                return '准时'
            } else {
                return '超时'
            }
        }
    },
    {
        title: '剩余时间', key: '',
        showData({clientTime, hairCarTime}) {
            const _m = Math.ceil(~~clientTime - (new Date() - new Date(hairCarTime)) / 60000);
            const _m2 = Math.abs(_m);
            const m = _m2 % 60;  //分钟数
            const s = (_m2 - m) / 60;
            let _mstr = '';
            if (_m < 0) _mstr = '-';
            if (s > 0) _mstr += `${s}时`;
            _mstr += `${m}分`;
            return _mstr;
        }
    },
    {title: '车号', key: 'carNo'},
    {title: '司机', key: 'driverName'},
    {title: '电话', key: 'driverTel'},
    {title: '承运商', key: 'supplierName', color: '#FFA200'}
]

const btnConfig = [
    {bg: '#19458C', title: '编 辑', key: 'update', role: 'Edit'},
    {bg: '#C6C6C6', title: '删 除', key: 'delete', role: 'Del'},
    {bg: '#F8B551', title: '确认到达', key: 'arrive', role: 'QRDD'},
    {title: '备注', key: 'remark', role: 'BZ'},
    {bg: '#C6C6C6', title: '编辑所有', key: 'EditALL', role: 'EditALL'},
]

const notRequired = true;

function fromConfig() {
    return [
        {column: '编 辑'},
        {title: '运单号', value: '', key: 'planOrder', type: 'input'},
        {title: '体积', value: '', key: 'volume', type: 'input'},
        {title: 'GPS号', value: '', key: 'gpsNo', type: 'input'},
        {title: '重量', value: '', key: 'weight', type: 'input'},
        {title: '始发地', value: '', key: 'provenance', type: 'input', notRequired},
        {title: '目的地', value: '', key: 'destination', type: 'input', notRequired},
        {
            title: '审核运单',
            value: [],
            key: 'auditWaybill',
            type: 'elcheckbox',
            notRequired,
            span: 16,
            transform(data) {
                this.value = data.auditWaybill ? data.auditWaybill.split(',') : [];
            },
            compose() {
                return {auditWaybill: this.value.join(',')};
            },
            list: [
                {label: '运单相符', value: '1'},
                {label: '运价正确', value: '2'},
                {label: '信息正确', value: '3'}
            ]
        },

    ]
}

function createRemark() {
    return [{title: '备注', value: '', key: 'remark', type: 'textarea', span: 24}]
}

export function createSearch(list) {
    const searchConfig = [
        {title: '发车时间', value: [], key: 'hairCarTime', type: 'date2'},
        {title: '运单号', value: '', key: 'planOrder', type: 'input'},
        {title: '线路', value: '', key: 'roadId', type: 'select', list},
        {title: '姓名', value: '', key: 'driverName', type: 'input'},
        {title: '电话', value: '', key: 'driverTel', type: 'input'},
        {title: '车牌号', value: '', key: 'carNo', type: 'input'}
    ]
    return searchConfig
}


function createArrive() {
    return [
        {column: '到达信息'},
        {title: '发车时间', value: '', key: 'hairCarTime', type: 'input', disabled: true},
        {title: '到达时间', value: '', key: 'arriveCarTime', type: 'date'},
        {
            title: '运输状态',
            value: '',
            key: 'statusOver',
            type: 'select',
            list: [{label: '准时', value: '1'}, {label: '超时', value: '2'}]
        },
        {title: '备注', value: '', key: 'remark', type: 'textarea', span: 24, notRequired}
    ]
}

const detailConfig = [
    {column: '派车信息'},
    {
        title: '线路',
        key: 'roadName',
        value: '',
    },
    {
        title: '运输方式',
        value: '',
        key: 'runType',
        transform(data) {
            const _data = {
                '1': '合流',
                '2': '整车',
                '3': '经停'
            }
            return _data[data[this.key]]
        }
    },
    {title: '总里程', value: '', key: 'mileage'},
    {
        title: '车型', value: '', key: 'carTypeId',
        transform(data) {
            const _data = {
                '1': '4.2米',
                '2': '6.8米',
                '3': '7.2米',
                '4': '9.6米',
                '5': '13米',
                '6': '14.2米',
                '7': '16.5米',
                '8': '17.5米',
            }
            return _data[data[this.key]]
        }
    },
    {title: '体积', value: '', key: 'volume'},
    {title: '重量', value: '', key: 'weight'},
    {
        title: '轴数',
        value: '',
        key: 'axleNum',
        transform(data) {
            const _data = {
                '2z': '2轴',
                '3z': '3轴',
                '4z': '4轴',
                '5z': '5轴',
                '6z': '6轴',
            }
            return _data[data[this.key]]
        }
    },
    {
        title: '始发地', value: '', key: 'startLocation',
        transform(data) {
            return data.provenance ? data.provenance : data.startLocation
        }
    },
    {title: '经停点', value: '', key: 'passLocation'},
    {
        title: '目的地', value: '', key: 'targetLocation',
        transform(data) {
            return data.destination ? data.destination : data.targetLocation
        }
    },
    {
        title: '客户时效',
        value: '',
        key: 'clientTime',
        transform({clientTime}) {
            const m = ~~clientTime % 60;
            const s = (~~clientTime - m) / 60;
            let _mstr = `${m}分`
            if (s > 0) _mstr = `${s}时` + _mstr
            return _mstr
        }
    },
    {title: '运单号', value: '', key: 'planOrder'},
    {title: 'GPS设备号', value: '', key: 'gpsNo'},
    {
        title: '平台结算', value: '', key: 'platformSettlementType',
        transform(data) {
            const _data = {
                1: '月结',
                2: '个体',
            }
            return _data[data[this.key]]
        }
    },
    {title: '平台收款人', value: '', key: 'payee'},
    {title: '创建日期', value: '', key: 'createTime'},
    {title: '装货时间', value: '', key: 'shipmentTime'},
    {title: '冻结时间（时）', value: '', key: 'freezingTime'},
    {column: '车辆信息 '},
    {title: '车牌号', value: '', key: 'carNo'},
    {title: '车型', value: '', key: 'carType'},
    {title: '挂车号', value: '', key: 'carGno'},
    {title: '司机', value: '', key: 'driverName'},
    {title: '电话', value: '', key: 'driverTel'},
    {title: '承运商', value: '', key: 'supplierName'},
    {title: '收款人', value: '', key: 'moneyp'},
    {title: '帐号', value: '', key: 'moneya'},
    {title: '开户行', value: '', key: 'bank'},
    {title: '调派员', value: '', key: 'dispatcherName'},
    {title: '发车时间', value: '', key: 'hairCarTime'},
    {title: '到达时间', value: '', key: 'arriveCarTime'},
    {
        title: '运输时长', value: '', key: '',
        transform(data) {
            const date3 = new Date(data.arriveCarTime) - new Date(data.hairCarTime);
            //计算出相差天数
            const days = Math.floor(date3 / (24 * 3600 * 1000))
            //计算出小时数
            const leave1 = date3 % (24 * 3600 * 1000)  //计算天数后剩余的毫秒数
            const hours = Math.floor(leave1 / (3600 * 1000))
            //计算相差分钟数
            const leave2 = leave1 % (3600 * 1000)    //计算小时数后剩余的毫秒数
            const minutes = Math.floor(leave2 / (60 * 1000))
            let _str = `${minutes}分`
            if ((hours + days * 24) > 0) _str = `${hours + days * 24}时` + _str
            return _str
        }
    },
    {
        title: '到达状态', value: '', key: 'statusOver',
        transform(data) {
            const _data = {
                '1': '准时',
                '2': '超时',
            }
            return _data[data[this.key]]
        }
    },
    {
        title: '回单回收', value: '', key: 'hdReply',
        isShowImg: true,
        imgKsy: 'hdPicture',
        transform(data) {
            const _data = {
                '1': '纸质回单已回收',
                '2': '无纸电子回单'
            }
            return _data[data[this.key]]
        }
    },
    {
        title: 'GPS设备回收', value: '', key: 'gps',
        isShowImg: true,
        imgKsy: 'gpsPicture',
        transform(data) {
            const _data = {
                '1': '临时外调已回收',
                '2': '长期合作固定设备'
            }
            return _data[data[this.key]]
        }
    },
    {column: '财务信息'},
    {title: '到车运费', value: '', key: 'tcFreight'},
    {
        title: '结算状态', value: '', key: 'statusJie',
        transform(data) {
            const _data = {
                1: '未结算',
                2: '审核中',
                3: '已通过',
                4: '部分结算',
                5: '已结算',
            }
            return _data[data[this.key]]
        }
    },
    {title: '结算时间', value: '', key: 'jieTime'},
    {title: '到车油卡', value: '', key: 'tcOilCard'},
    {title: '油卡充值方式', value: '', key: 'oilPayType'},
    {title: '充值时间', value: '', key: 'oilPayTime'},
    {title: '押金', value: '', key: 'yaMoney'},
    {title: '保险', value: '', key: 'insurance'},
    {title: '罚款', value: '', key: 'fine'},
    {title: '补助', value: '', key: 'subsidy'},
    {title: '结算金额', value: '', key: 'jieMoney'},
    {
        title: '审核运单',
        key: 'auditWaybill', span: 16, value: '',
        transform(data) {
            if (!data.auditWaybill) return ''
            return [
                {label: '运单相符', value: '1'},
                {label: '运价正确', value: '2'},
                {label: '信息正确', value: '3'}
            ].filter(item => data.auditWaybill.split(",")
                .indexOf(item.value) > -1).map(x => x.label).join("，");
        }
    },
    {column: '备注'},
    {
        key: 'operation_remark', span: 24, value: '',
        transform(data) {
            return data.remarks
        }
    },
    {column: '异常上报'},
    {
        key: 'operation_orderRunTrackList', span: 24, value: '',
        transform(data) {
            return data.orderRunTrackList
        }
    },
    {column: '操作记录'},
    {
        key: 'operation_record', span: 24, value: '',
        transform(data) {
            return data.logs
        }
    },
]

function createAllFrom(roadList = [], carTypeList = [], supplierList = []) {
    const notParam = true;
    const querySearch = (api) => {
        return async (key, cb) => {
            const [res] = await asyncAjax(api, {key});
            cb(res.data)
        }
    }
    return function () {
        const fromConfig = [
            {column: '新 建'},
            {
                title: '线路',
                value: '',
                key: 'road',
                type: 'select',
                list: roadList,
                change() {
                    const road = _findItem(fromConfig, 'road');
                    const params = road.list.filter(item => item.value == road.value)[0];
                    getValue(['mileage', 'startLocation', 'targetLocation', 'clientTime'], params)
                },
                compose() {
                    const {label, value, ...params} = this.list.filter(item => item.value == this.value)[0];
                    return {[this.key]: params, roadId: params.roadId}
                },
                transform(data) {
                    this.value = data.roadId;
                    getValue(['mileage', 'startLocation', 'targetLocation', 'clientTime'], data)
                }
            },
            {
                title: '运输方式',
                value: '',
                key: 'runType',
                type: 'select',
                list: [{label: '合流', value: '1'}, {label: '整车', value: '2'}, {label: '经停', value: '3'}]
            },
            {
                title: '运输状态',
                value: '',
                key: 'statusOver',
                type: 'select',
                list: [{label: '准时', value: '1'}, {label: '超时', value: '2'}]
                , notRequired
            },
            {title: '发车时间', value: '', key: 'hairCarTime', type: 'date', notRequired},
            {title: '到达时间', value: '', key: 'arriveCarTime', type: 'date', notRequired},
            {title: '总里程', value: '', key: 'mileage', type: 'input', disabled: true, notParam},
            {
                title: '车型', value: '', key: 'carTypeId', type: 'select', list: carTypeList
            },
            {title: '体积', value: '', key: 'volume', type: 'input', notRequired},
            {title: '重量', value: '', key: 'weight', type: 'input', notRequired},
            {title: '始发地', value: '', key: 'startLocation', type: 'input', disabled: true, notParam},
            {title: '经停点', value: '', key: 'passLocation', type: 'input', notRequired},
            {title: '目的地', value: '', key: 'targetLocation', type: 'input', disabled: true, notParam},
            {title: '客户时效', value: '', key: 'clientTime', type: 'input', disabled: true, notParam},
            {title: '运单号', value: '', key: 'planOrder', type: 'input', notRequired},
            {title: 'GPS设备号', value: '', key: 'gpsNo', type: 'input', notRequired},
            {
                title: '平台结算', value: '', key: 'platformSettlementType', type: 'select', notRequired,
                list: [{label: '月结', value: 1}, {label: '个体', value: 2}]
            },
            {title: '收款人', value: '', key: 'payee', type: 'input', notRequired},
            {column: '车辆信息'},
            {
                title: '车牌号',
                value: '',
                key: 'car',
                type: 'autocomplete',
                valueKey: 'carNo',
                obj: {},
                querySearch: querySearch(SearchCar),
                select(data) {
                    const _item = _findItem(fromConfig, 'car');
                    _item.obj = data;
                    getValue(['carGno'], data)
                },
                compose() {
                    const {obj, valueKey, value, key} = this;
                    if (obj && obj[valueKey] === value) {
                        obj.carType = _findItem(fromConfig, 'carTypeId').value;
                        return {[key]: obj, carId: obj.carId}
                    } else {
                        if (value.length !== 7) {
                            return {error: '车牌号必须为七位数'}
                        }
                        return {
                            [key]: {
                                carType: _findItem(fromConfig, 'carTypeId').value,
                                carGno: _findItem(fromConfig, 'carGno').value,
                                carNo: value
                            }
                        }
                    }
                },
                change() {
                    const _item = _findItem(fromConfig, 'car')
                    setTimeout(() => {
                        let _state = false;
                        if (_item.obj && _item.obj[_item.valueKey] === _item.value) {
                            _state = true;
                        }
                        getValue(['carGno'], null, {k: 'disabled', v: _state})
                    }, 0)
                },
                transform(data) {
                    this.value = data[this.valueKey];
                    getValue(['carGno'], data)
                    if (data.carId) {
                        this.obj = {
                            carGno: data.carGno,
                            carId: data.carId,
                            carNo: data.carNo,
                            carType: data.carType,
                            remark: data.remark
                        }
                    }

                    this.change()
                }
            },
            {title: '挂车号', value: '', key: 'carGno', type: 'input', disabled: false, notParam, notRequired},
            {
                title: '承运商',
                value: '',
                key: 'supplier',
                type: 'select',
                list: supplierList,
                change() {
                    const _supplier = _findItem(fromConfig, 'supplier')
                    let obj = {}
                    _supplier.list.forEach(item => obj[item.value] = {
                        moneya: item.moneya,
                        moneyp: item.moneyp,
                        bank: item.bank
                    });
                    let moneya = obj[_supplier.value].moneya;
                    let moneyp = obj[_supplier.value].moneyp;
                    let bank = obj[_supplier.value].bank;
                    _supplier.obj = {moneya, moneyp, bank}
                    // 填充字段
                    setSupplierAndDriver()
                },
                compose() {
                    const {supplierId, ...params} = this.list.filter(item => item.value === this.value)[0];
                    return {[this.key]: params, supplierId}
                },
                transform(data) {
                    this.value = data.supplierId
                }
            },
            {
                title: '司机',
                value: '',
                key: 'driver',
                type: 'autocomplete',
                valueKey: 'name',
                valueKeyTitle: ['name', 'tel'],
                obj: {},
                span: 16,
                querySearch: querySearch(SearchDriver),
                select(data) {
                    const _item = _findItem(fromConfig, 'driver');
                    _item.obj = data;
                    getValue(['tel'], data);
                    // 填充字段
                    setSupplierAndDriver()
                },
                change() {
                    const _item = _findItem(fromConfig, 'driver')
                    setTimeout(() => {
                        let _state = false
                        if (_item.obj && _item.obj[_item.valueKey] === _item.value) {
                            _state = true;
                        } else {
                            _item.obj.driverId = ''
                        }
                    }, 0)
                },
                compose() {
                    const {obj, key} = this;
                    let _tel = _findItem(fromConfig, 'tel').value;
                    if (_tel.length !== 11) return {error: '电话号码必须为11位'};
                    return {
                        [key]: {
                            driverId: obj.driverId,
                            tel: _tel,
                            moneyp: _findItem(fromConfig, 'moneyp').value,
                            moneya: _findItem(fromConfig, 'moneya').value,
                            bank: _findItem(fromConfig, 'bank').value,
                            name: this.value
                        }
                    }
                },
                transform(data) {
                    this.value = data.driver
                    this.obj = data[this.key];
                    this.value = data.driverName;
                    getValue(['tel', 'moneyp', 'moneya', 'bank', 'dispatcherName'], {
                        tel: data.driverTel,
                        bank: data.bank,
                        moneya: data.moneya,
                        moneyp: data.moneyp,
                        dispatcherName: data.dispatcherName
                    });
                    if (data.driverId) {
                        this.obj = {
                            bank: data.driverbank,
                            driverId: data.driverId,
                            moneya: data.driverMoneya,
                            moneyp: data.driverMoneyp,
                            name: data.driverName,
                            remark: data.remark,
                            tel: data.driverTel
                        }
                    }
                    this.change()
                    setSupplierAndDriver()
                }
            },
            {title: '电话', value: '', key: 'tel', type: 'input', disabled: false, notParam},
            {title: '收款人', value: '', key: 'moneyp', type: 'input', disabled: false, notParam, notRequired},
            {title: '帐号', value: '', key: 'moneya', type: 'input', disabled: false, notParam, notRequired},
            {title: '开户行', value: '', key: 'bank', type: 'input', disabled: false, notParam, notRequired},
            {
                title: '调派员',
                value: store.state.user.userInfo.username,
                key: 'dispatcherName',
                type: 'input',
                disabled: true,
                notParam
            },
            {
                title: '到车运费', value: '', key: 'tcFreight', type: 'input', notRequired,
                compose() {
                    if (this.value && this.value.length > 5) return {error: '到车运费最多为5位数'}
                    return {[this.key]: this.value}
                }
            },
            {
                title: '到车油卡', value: '', key: 'tcOilCard', type: 'input', notRequired,
                compose() {
                    if (this.value) {
                        if (this.value && this.value.length > 5) return {error: '到车油卡最多为5位数'}
                        return {[this.key]: this.value}
                    } else {
                        return {}
                    }
                }
            },
            {column: '财务信息'},
            {title: '到车运费', value: '', key: 'tcFreight', type: 'input', notRequired},
            {
                title: '结算方式',
                value: '',
                key: 'jieType',
                type: 'select',
                list: [
                    {label: '全部结算', value: 1},
                    {label: '部分结算', value: 2}
                ], notRequired
            },
            {
                title: '结算状态', value: '', key: 'statusJie', type: 'select',
                list: [
                    {label: '未结算', value: 1},
                    {label: '审核中', value: 2},
                    {label: '已通过', value: 3},
                    {label: '部分结算', value: 4},
                    {label: '已结算', value: 5}
                ], notRequired
            },
            {title: '结算时间', value: '', key: 'jieTime', type: 'date', notRequired},
            {title: '到车油卡', value: '', key: 'tcOilCard', type: 'input', notRequired},
            {title: '油卡充值方式', value: '', key: 'oilPayType', type: 'input', notRequired},
            {title: '充值时间', value: '', key: 'oilPayTime', type: 'date', notRequired},
            {title: '押金', value: '', key: 'yaMoney', type: 'input', notRequired},
            {title: '保险', value: '', key: 'insurance', type: 'input', notRequired},
            {title: '罚款', value: '', key: 'fine', type: 'input', notRequired},
            {title: '补助', value: '', key: 'subsidy', type: 'input', notRequired},
            {title: '申请金额', value: '', key: 'applyMoney', type: 'input', notRequired},
            {title: '结算金额', value: '', key: 'jieMoney', type: 'input', notRequired},
        ]
        const getValue = (arr, data, _key) => {
            arr.forEach(key => {
                const _item = _findItem(fromConfig, key);
                _key ? _item[_key.k] = _key['v'] : _item.value = data[key]
            })
        }
        const setSupplierAndDriver = () => {
            /*
            张亚楠-飞帆:
            承运商名下有收款账户信息，在选择司机的时候不可以覆盖
            张亚楠-飞帆:
            承运商名下没有收款账户信息选择司机的时候可以用司机收款账户信息覆盖*/
            const _supplier = _findItem(fromConfig, 'supplier')
            const _driver = _findItem(fromConfig, 'driver');
            let sObj = _supplier.obj ? _supplier.obj : _supplier.list.filter(x=>x.supplierId===_supplier.value)[0]
            let dObj = _driver.obj ? _driver.obj : {}
            // 先设置司机，覆盖承运商
            let data = {
                moneyp: sObj.moneyp ? sObj.moneyp : dObj.moneyp,
                moneya: sObj.moneya ? sObj.moneya : dObj.moneya,
                bank: sObj.bank ? sObj.bank : dObj.bank
            }
            getValue(['moneyp', 'moneya', 'bank'], data);
        }
        return fromConfig
    }
}

export default function config() {
    return {
        listConfig,
        btnConfig,
        detailConfig,
        fromConfig,
        createSearch,
        createArrive,
        createRemark,
        createAllFrom,
        apis: Transit
    }
}
